module.exports = "<mat-expansion-panel class=\"br-expansion-panel\">\n  <mat-expansion-panel-header>\n    <mat-panel-title>\n     <span style=\"font-family: 'Lato'; font-size: 14px;\">{{title}}</span>\n    </mat-panel-title>\n  </mat-expansion-panel-header>\n  <ng-content select=\"[body]\"></ng-content>\n</mat-expansion-panel>\n        "


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/br-expansion-panel/br-expansion-panel.component.html
// module id = ../../../../../src/app/brds/widgets/br-expansion-panel/br-expansion-panel.component.html
// module chunks = 10